import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-2xl font-bold text-foreground-900 font-heading"
              style={{ fontFamily: "'Ma Shan Zheng', cursive" }}
            >
              妖精漫画
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              妖精漫画免费弹窗入口，支持下拉式在线阅读，主打奇幻、魔法、妖精题材漫画大全，涵盖韩漫、日漫、国漫等多种题材。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">奇幻漫画</Link>
              <Link to="/category/fairy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">妖精题材</Link>
              <Link to="/category/magic" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">魔法漫画</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/korean" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">韩漫精选</Link>
              <Link to="/category/japanese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">日漫经典</Link>
              <Link to="/category/chinese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">国漫崛起</Link>
              <Link to="/category/adventure" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">冒险热血</Link>
              <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">恋爱甜宠</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                contact@yaojingmanhua.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-500"></i>
                在线客服：工作日 9:00-18:00
              </p>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 妖精漫画. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}